import type { Plugin } from "vue";
import App from "@/app.vue";

export function initVueApp() {
  // Create root component from @/app.vue
  const appElement = document.getElementById("app");
  const innerHTML = appElement?.innerHTML || "";
  const app = createApp({
    render() {
      return h(App, null, {
        default: () => h({ template: innerHTML }),
      });
    },
  });

  // Load all Vue plugins from @/plugins/*.ts
  const plugins: Record<string, { default: Plugin }> = import.meta.glob("@/plugins/*.ts", { eager: true });
  Object.keys(plugins).forEach((key) => {
    app.use(plugins[key].default);
  });

  // Mount Vue app to #app
  app.mount("#app");
}
